import { Container } from '../../components/container/container';
import { LocationIcon } from '@y2/mango/components/icons';
import styles from './sub-header.module.scss';
import texts from './sub-header.texts.json';
import cn from 'classnames';
import React from 'react';
import { DeveloperUnknownLogo } from '../../components/developer-unknown-logo/developer-unknown-logo';

type Props = {
  className?: string;
  projectName: string;
  address: string;
  developerName: string;
};

export const SubHeader = ({
  className,
  projectName,
  developerName,
  address,
}: Props) => {
  return (
    <div className={cn(styles.subHeaderBox, className)}>
      <Container>
        <div className={cn(styles.subHeaderContentBox, className)}>
          <div className={styles.subHeaderContent}>
            <h1 className={styles.heading}>{projectName}</h1>
            <address className={styles.subHeading}>
              <LocationIcon className={styles.locationIcon} />
              {address}
            </address>
          </div>
          <div className={styles.logoBox}>
            <DeveloperUnknownLogo title={developerName} />
          </div>
        </div>
      </Container>
    </div>
  );
};
